export const CampaignButtonType = Object.freeze({
	Close: 1,
	Link: 2,
	Action: 3,
});

export const CampaignType = Object.freeze({
	Banner: 1,
	Modal: 2,
});

export const CampaignButtonPosition = Object.freeze({
	Primary: 1,
	Secondary: 2,
});

export const ActionIdMap = Object.freeze({
	1: {
		action: 'Upgrade',
	},
	2: {
		action: 'CampaignSettings',
		params: 'GENERAL_COMMON',
		settings: 'common',
	},
	3: {
		action: 'CampaignSettings',
		params: 'SHIPPING_ADDRESSES',
		settings: 'common',
	},
	4: {
		action: 'CampaignSettings',
		params: 'SERVICE_OPTIONS',
		settings: 'common',
	},
	5: {
		action: 'CampaignSettings',
		params: 'GENERAL_MAIL',
		settings: 'mail',
	},
	6: {
		action: 'CampaignSettings',
		params: 'PRINT_OPTIONS',
		settings: 'mail',
	},
	7: {
		action: 'CampaignSettings',
		params: 'STORES',
		settings: 'orders',
	},
	8: {
		action: 'CampaignSettings',
		params: 'INTERNATIONAL',
		settings: 'orders',
	},
	9: {
		action: 'CampaignSettings',
		params: 'AUTOMATION_RULES',
		settings: 'orders',
	},
	10: {
		action: 'CampaignSettings',
		params: 'LABEL_MESSAGES',
		settings: 'orders',
	},
	11: {
		action: 'CampaignSettings',
		params: 'LABEL_IMAGE',
		settings: 'common',
	},
	12: {
		action: 'Link',
		params: 'CUSTOMER_MARKETING',
		settings: 'common',
	},
	13: {
		action: 'CampaignSettings',
		params: 'CARRIERS',
		settings: 'common',
	},
	14: {
		action: 'AddCarrier',
		params: 'UPS',
	},
});
